import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import "./ProductSelectorItem.scss";
import { Typography } from "antd";
import classNames from "classnames";
/**
 * The ProductItem component displays a product item with an icon and a name.
 * E.g. for when displaying a product in a menu or similar context.
 * It supports opening the link in a new tab and styling the item as selected if it is the current product.
 */
export const ProductSelectorItem = ({ openNewTab = false, name, href, icon, isCurrentProduct = false }) => {
    return (_jsx("li", { children: _jsxs("a", { "data-testid": "product-selector__item", className: classNames("product-selector__item te-flex te-flex-col te-items-center te-no-underline te-w-[112px]", {
                "product-selector__item--selected": isCurrentProduct
            }), href: href || "#", target: openNewTab ? "_blank" : "_self", role: "menuitem", "aria-current": isCurrentProduct, "aria-label": name, children: [icon && (_jsx("div", { "aria-hidden": true, className: "product-selector__item__logo te-leading-[0px]", children: icon })), _jsx(Typography.Text, { children: name })] }) }));
};
